import { CheckCircleIcon, XCircleIcon } from '@heroicons/react/outline';
import { Badge, Card, SkeletonLoader } from '@yoast/ui-library';
import cx from 'classnames';

import TextScore from '../../components/TextScore';
import TitleWithTooltip from '../../components/TitleWithTooltip';
import useScan from '../../hooks/useScan';

const MentionsCard = () => {
  const { data, isLoading, isRefetching } = useScan();

  const mentions = data?.mentions;

  return (
    <Card className="yst-overflow-visible">
      <Card.Content className="yst-space-y-4">
        <div className="yst-space-y-2">
          <TitleWithTooltip
            title="Mentions"
            // https://www.figma.com/design/zH43jZJuvZyPaqrod8lG5u?node-id=138-2053#1353633825
            tooltip="The queries where your brand was mentioned."
          />

          <TextScore
            score={mentions?.mentionedInNumberOfQueries?.value}
            total={mentions?.queriesWithMentions?.length} // TODO - confirm
            suffix="queries"
            isLoading={isLoading || isRefetching}
          />
        </div>

        {!isLoading && mentions ? (
          <ul>
            {mentions?.queriesWithMentions?.map((mention, idx) => {
              const isFirst = idx === 0;
              const isLast =
                mentions.queriesWithMentions &&
                idx === mentions.queriesWithMentions.length - 1;
              return (
                <li
                  key={mention.query}
                  className={cx(
                    'yst-flex yst-flex-row yst-items-center yst-gap-2 yst-border-l yst-border-r yst-border-slate-300 yst-p-4 yst-font-medium yst-text-slate-800',
                    {
                      'yst-rounded-t-lg yst-border-t': isFirst,
                      'yst-rounded-b-lg yst-border-b': isLast,
                      'yst-border-b': !isLast,
                    },
                  )}
                >
                  <div className="yst-h-4 yst-w-4">
                    {mention?.mentioned ? (
                      <CheckCircleIcon className="yst-text-green-500" />
                    ) : (
                      <XCircleIcon className="yst-text-red-500" />
                    )}
                  </div>
                  <span className="yst-justify-start">{mention.query}</span>
                  <span className="yst-ml-auto yst-flex yst-items-end">
                    {mention?.mentioned ? (
                      <Badge className="yst-bg-green-100 yst-text-green-800">
                        Found
                      </Badge>
                    ) : (
                      <Badge className="yst-bg-red-100 yst-text-red-800">
                        Not found
                      </Badge>
                    )}
                  </span>
                </li>
              );
            })}
          </ul>
        ) : (
          <SkeletonLoader className="yst-h-56 yst-w-full" />
        )}
      </Card.Content>
    </Card>
  );
};

export default MentionsCard;
